<script>import { melt } from "@melt-ui/svelte";
import { createDispatcher } from "../../../internal/index.js";
import { getCtx, getAttrs, updatePositioning } from "../ctx.js";
export let transition = void 0;
export let transitionConfig = void 0;
export let inTransition = void 0;
export let inTransitionConfig = void 0;
export let outTransition = void 0;
export let outTransitionConfig = void 0;
export let asChild = false;
export let id = void 0;
export let side = "top";
export let align = "center";
export let sideOffset = 0;
export let alignOffset = 0;
export let collisionPadding = 8;
export let avoidCollisions = true;
export let collisionBoundary = void 0;
export let sameWidth = false;
export let fitViewport = false;
export let strategy = "absolute";
export let overlap = false;
const {
  elements: { content },
  states: { open },
  ids
} = getCtx(sideOffset);
const dispatch = createDispatcher();
const attrs = getAttrs("content");
$:
  if (id) {
    ids.content.set(id);
  }
$:
  builder = $content;
$:
  Object.assign(builder, attrs);
$:
  updatePositioning({
    side,
    align,
    sideOffset,
    alignOffset,
    collisionPadding,
    avoidCollisions,
    collisionBoundary,
    sameWidth,
    fitViewport,
    strategy,
    overlap
  });
</script>

{#if asChild && $open}
	<slot {builder} />
{:else if transition && $open}
	<div
		{...builder} use:builder.action
		transition:transition={transitionConfig}
		{...$$restProps}
		on:m-pointerdown={dispatch}
		on:m-pointerenter={dispatch}
	>
		<slot {builder} />
	</div>
{:else if inTransition && outTransition && $open}
	<div
		{...builder} use:builder.action
		in:inTransition={inTransitionConfig}
		out:outTransition={outTransitionConfig}
		{...$$restProps}
		on:m-pointerdown={dispatch}
		on:m-pointerenter={dispatch}
	>
		<slot {builder} />
	</div>
{:else if inTransition && $open}
	<div
		{...builder} use:builder.action
		in:inTransition={inTransitionConfig}
		{...$$restProps}
		on:m-pointerdown={dispatch}
		on:m-pointerenter={dispatch}
	>
		<slot {builder} />
	</div>
{:else if outTransition && $open}
	<div
		{...builder} use:builder.action
		out:outTransition={outTransitionConfig}
		{...$$restProps}
		on:m-pointerdown={dispatch}
		on:m-pointerenter={dispatch}
	>
		<slot {builder} />
	</div>
{:else if $open}
	<div
		{...builder} use:builder.action
		{...$$restProps}
		on:m-pointerdown={dispatch}
		on:m-pointerenter={dispatch}
	>
		<slot {builder} />
	</div>
{/if}
